<template lang="pug">
  .container-fluid Sorry, looks like you have no access.  If you feel this is in error, please contact us.
</template>

<script>
export default {
  name: 'NoAccess'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
</style>
